import React from 'react';

const Colorado = () => (
  <svg
    width="98"
    height="76"
    viewBox="0 0 98 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.53335 0.54541C38.1022 3.71381 67.1569 6.40343 97.0704 8.22702C95.6201 30.4973 95.0076 53.6126 93.487 75.8055C62.1443 73.7847 31.2733 71.0388 0.831749 67.6169C0.726147 65.0258 1.0007 62.118 1.34566 59.4283C3.69003 41.1502 6.43569 20.4641 9.02646 2.08737C8.97718 1.35511 8.93494 0.636942 9.53335 0.54541Z"
      fill="#FC374D"
    />
  </svg>
);
export default Colorado;
